<!-- Id'de wrapper voor 'sleep thumbnail → hoofdfoto': ImageTablistComponent hittest hiertegen
     (document.getElementById(_mainDropId), zie emit_onDragMoved/__isOverMainBox daar) i.p.v. een
     CDK-cross-list-transfer. Alleen renderen als slepen mag, zodat er geen dubbel id ontstaat bij
     meerdere image-box-details. -->
@if (dropEnabled$$()) {
    <div class="photo-drop" [id]="_mainDropId">
        <ng-container [ngTemplateOutlet]="boxTpl" />
    </div>
} @else {
    <ng-container [ngTemplateOutlet]="boxTpl" />
}

<ng-template #boxTpl>
    <app-image-box-link
        (loaded)="emit_onLoaded()"
        (onClickEmit)="emit_onClick($event)"
        [border]="border$$()"
        [guid]="guid$$()"
        [version]="version$$()"
        [noClick]="noClick$$() || (!canUpload$$() && !guid$$())"
        [highlight]="dragActive$$()"
    >
        @if (canUpload$$() && !noClick$$() && !guid$$()) {
            <!-- Puur visuele hint: de hele box is al klikbaar (zie emit_onClick), dus geen
                 geneste knop meer nodig — die was overbodig en blokkeerde ooit de klik zelf. -->
            <div class="upload-actions-anim"
                    [@showHide]="{ value: '', params: { enterTime: _showHideEnterTime$$(), leaveTime: _showHideLeaveTime$$() } }">
                <div class="upload-actions">
                    <app-icon name="camera-plus" />
                </div>
            </div>
        }
    </app-image-box-link>
</ng-template>

<input
    #galleryInput
    type="file"
    accept="image/*"
    hidden
    (change)="emit_fileChange($event)"
/>

<!-- In-pagina camera (getUserMedia): vervangt de externe camera-app zodat mobiele browsers niet
     i.p.v. de camera de galerij-picker tonen (of de tab herladen). -->
@if (cameraOpen$$()) {
    <app-camera-capture (captured)="emit_cameraCaptured($event)" (closed)="emit_cameraClosed()" />
}
